import { Component, OnInit } from '@angular/core';
import { Role } from '../../core/enums/role.enum';
import { AuthService } from '../../core/services/auth.service';
import { NavService } from '../../core/services/nav.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {

  isLoggedIn = false;
  isFotiouAdmin = false;
  isCustomerAdmin = false;
  isCustomerService = false;

  constructor(
    public _authService: AuthService,
    public _navService: NavService
  ) { }

  ngOnInit(): void {
    this.isLoggedIn = this._authService.isLoggedIn();
    this.isFotiouAdmin = this._authService.getLoggedInUser()?.roleId == Role.FotiouAdmin;
    this.isCustomerAdmin = this._authService.getLoggedInUser()?.roleId == Role.CustomerAdmin;
    this.isCustomerService = this._authService.getLoggedInUser()?.roleId == Role.FotiouCustomerService;
  }

}
